import React, { memo } from 'react'

import { Textarea } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, oneOf, string } from 'prop-types'

import { MODEL_FEEDBACK_MIN_COMMENT_LENGTH } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import { COMMENT_ERROR } from '../../Utils/getCommentError'

const FIELD_ID = 'model-feedback-comment'
const ERROR_ID = 'model-feedback-comment-error'

function CommentField({ value, isRequired, error = null, onChange }) {
  const t = useTranslation()
  const isErrorShown = error != null

  return (
    <div className="model-feedback__comment">
      <label htmlFor={FIELD_ID} className="cgt-body-base-semibold model-feedback__comment-label">
        {t('viewer.modelFeedback.comment.label')}
        {isRequired && <span className="model-feedback__required" aria-hidden="true"> *</span>}
      </label>
      {isErrorShown && (
        <p id={ERROR_ID} className="cgt-caption-semibold model-feedback__comment-error" role="alert">
          {t(`viewer.modelFeedback.comment.${error}`, { min: MODEL_FEEDBACK_MIN_COMMENT_LENGTH })}
        </p>
      )}
      <Textarea
        id={FIELD_ID}
        isPilot
        textareaClassName="model-feedback__comment-field"
        className="cgt-body-base"
        placeholder={t('viewer.modelFeedback.comment.placeholder')}
        value={value}
        required={isRequired}
        isWarning={isErrorShown}
        aria-invalid={isErrorShown}
        aria-describedby={isErrorShown ? ERROR_ID : undefined}
        onChange={onChange}
      />
    </div>
  )
}

CommentField.propTypes = {
  value: string.isRequired,
  isRequired: bool.isRequired,
  error: oneOf(Object.values(COMMENT_ERROR)),
  onChange: func.isRequired,
}

export default memo(CommentField)
